import { EActionCode } from 'affiny-core/modules/api/repositories/payment/paymentActionCodes';
import { goToRateCardActions } from 'affiny-core/redux/actions/goToRatecardActions';
import { Button, Flex, rem, Title } from 'affiny-ui/src';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

export const REGHEADBAND_HEIGHT = rem(60);

export const MainLayoutRegHeadband = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const goToRateCard = () =>
    dispatch(
      goToRateCardActions.goToRateCard({
        actionCode: EActionCode.CTA_BANDEAU_HOME,
      })
    );

  return (
    <Flex
      bg="caribbeanGreen"
      height={REGHEADBAND_HEIGHT}
      alignItems="center"
      justifyContent="center"
      cursor="pointer"
      onClick={goToRateCard}
      data-test="goToRateCard-whypremium"
    >
      <Title fontSize={rem(18)} color="light" mr="xLarge">
        {t('ratecards.header.label')}
      </Title>
      <Button
        onClick={goToRateCard}
        color="subscription"
        size="small"
        shadow
        text={t('ratecards.action')}
      />
    </Flex>
  );
};
